import { CommonModule, Location } from '@angular/common';
import { booleanAttribute, Component, inject, input } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { Icon } from '../../icon/icon.component';
import { ModalService } from 'libs/client-libs/src/services/services';

@Component({
  selector: 'app-page-modal-container',
  standalone: true,
  imports: [CommonModule, Icon, RouterModule],
  template: `<main
    [class.xl:hidden]="!desktop()"
    [class.slide]="slideEnabled()"
    [ngClass]="mainClass() ? mainClass() : 'bg-white'"
    class=" overflow-x-hidden absolute z-[999] inset-0 w-full min-h-svh h-full slide"
  >
    <section
      [ngClass]="[
        headerClass() ? headerClass() : 'bg-white border-b border-gray-100',
        icons() ? icons() : 'p-4',
      ]"
      class="fixed top-0 z-10 flex justify-between w-full p-4 "
    >
      <div
        class="flex w-fit"
        [ngClass]="
          close()
            ? 'items-end justify-end w-full'
            : 'items-center justify-start'
        "
      >
        <app-icon
          (click)="goBack($event)"
          [name]="
            close()
              ? 'material-symbols:close'
              : 'material-symbols:arrow-back-ios'
          "
          [ngClass]="iconClass() ? iconClass() : 'text-gray-700'"
          class="cursor-pointer "
          size="sm"
        />
      </div>

      <ng-content select="[icons]" />
    </section>

    <section class="z-50 h-full pt-[52px]">
      <ng-content />
    </section>

    <section
      [ngClass]="
        mainClass() ? mainClass() : 'bg-white border-t border-gray-100'
      "
      class="fixed bottom-0 w-full  "
    >
      <ng-content select="[footer]" />
    </section>
  </main> `,
})
export class PageModalContainer {
  readonly modalService = inject(ModalService);
  readonly location = inject(Location);
  readonly router = inject(Router);

  close = input(false, { transform: booleanAttribute });
  desktop = input(false, { transform: booleanAttribute });
  slideEnabled = input(true, { transform: booleanAttribute });
  goBackUrl = input('');

  icons = input('');
  headerClass = input('');
  mainClass = input('');
  iconClass = input('');

  goBack(ev?: Event) {
    ev?.stopPropagation();
    ev?.preventDefault();

    if (this.close()) {
      this.modalService.close();
      return;
    }

    if (this.goBackUrl()) {
      this.router.navigate([this.goBackUrl()], { replaceUrl: true });
      this.modalService.close();
      return;
    }

    this.location.back();
  }
}
